import React, { Fragment, useEffect, useRef, useState } from 'react';
import Blur from 'react-css-blur';
import { ToolTips } from '../../components/tooltips/ToolTips';
import { Button, ButtonGroup, CardBody, Col, Container, Row, FormGroup, Label, Input, Pagination, Card, CardHeader } from 'reactstrap';
import { useSpecialDiscount } from '../../hooks/specialDiscounts/useSpecialDiscount';
import { ModalInformation } from '../../components/specialDiscounts/ModalInformation';
import { ModalSpecialDiscount } from '../../components/specialDiscounts/ModalSpecialDiscount';
import { ListCardSpecialDiscounts } from '../discounts/ListCardSpecialDiscount';
import List from 'list.js';
import Select from 'react-select';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import './StyleDiscount.css'
import { TitleDataTable } from '../../components/tableDataTable/TitleDataTable';
import { AlertDataTable } from '../../components/tableDataTable/AlertDataTable';

export const IndexSpecialDiscount = () => {

    const {
        //MODALS
        modalTitle,
        modalInformation, toggleInformation, methodInformation,
        modalSpecialDiscount, closeDialogSpecialDiscount, methodSpecialDiscount,

        //SPECIAL DISCOUNT MODEL        
        loading, listSpecialDiscounts, listExams, listProfiles, listSelectedExams, listSelectedProfiles,

        id_user, code, id_exam_profile, percentage, percentage_global,
        id_exam_include, id_profile_include, password,
        validationsSpecialDiscount, idSpecialDiscount,
        validCode,

        //SPECIAL DISCOUNTS METHODS
        handleInputChange, handleChangeTypeDiscount, handleExamsIncludes, handleProfileIncludes,
        handleInputPercentageIndividual,
        handleCreate, saveCreate,
        handleRemoveTest,
        handleAuthorized, saveAuthorized,
        handleUpdate, saveUpdate,
        handleDelete, saveDelete,
        handleShowValidCode, getInformationSpecialDiscount, dataCode, validName, valid_percentage,

        //Filter 
        mDateRange1, mDataRange2, selectedStatus, setSelecUsed, getFilter, handleSearchChange,

        modalAlert, showDeleteAlert, closeDeleteAlert, searchDiscount, handleSearchDiscount, setSearchDiscount, setListSpecialDiscounts,
        listDiscountSearch, handleExcelSpecialDiscount, loadingExport

    } = useSpecialDiscount();

    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };
    

    const actions = (rowData) => {

        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
                {rowData.status !== "authorized" && (
                    <>
                <Button
                    color="success"
                    size="sm"
                    onClick={() => handleAuthorized(rowData.id_special_discount)}
                    disabled={loading}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >
                    <i className="fa fa-lock"></i>
                </Button>

                <Button
                    color="primary"
                    size="sm"
                    onClick={() => handleUpdate(rowData.id_special_discount)}
                    disabled={loading}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}

                >
                    <i className="fa fa-edit"></i>
                </Button>


                <Button
                    color="danger"
                    size="sm"
                    onClick={() => handleDelete(rowData.id_special_discount)}
                    disabled={loading}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",   
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >
                    <i className="fa fa-trash"></i>
                </Button>
                </>
    )}
                {rowData.status === "authorized" && 
                    <Button
                        color="primary"
                       onClick={() => handleUpdate(rowData.id_special_discount, "view")}
                        disabled={loading}
                        style={{
                            padding: "2px",
                            fontSize: "1rem",
                            height: "26px",
                            width: "26px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }}
                    >
                        <i className="fa fa-eye"></i>
                    </Button>
                }


            </div>
        );
    };

    

    return (
        <Fragment>
            <Container fluid={true} className='container-global-zoom p-1'>

                <Card style={{
                    marginBottom: '15px',
                    background: 'linear-gradient(135deg, #002940 0%, #1d5b83 100%)',
                    border: 'none',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                }}>
                    <CardBody style={{ padding: '18px 25px' }}>
                        <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center">
                                <div style={{
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '12px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginRight: '15px'
                                }}>
                                    <img alt="flask" className="img-fluid text-info mr-2" src={require("../../assets/images/laboratory-External/discount-img.png")} style={{ width: "60px", height: "60px" }} />
                                </div>
                                <div>
                                    <h4 className="mb-1" style={{ color: '#fff', fontWeight: 700, fontSize: '20px', textAlign: "justify" }}>
                                        Descuentos especiales
                                    </h4>
                                    <small style={{ color: 'rgba(255,255,255,0.85)', fontSize: '13px' }}>
                                        <i className="fa fa-info-circle mr-1"></i>
                                        Gestión de descuentos especiales por examen o perfil, de manera individual o global.                                    </small>
                                </div>
                            </div>

                        </div>
                    </CardBody>
                </Card>

                <Card className='shadow-sm border height-equal' >
                    <Col sm="12">
                        <Row>
                            <Col sm="2" className='p-l-0 p-r-0' style={{ textAlign: "left" }}>
                                <Card style={{
                                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                    border: 'none',
                                    height: '100%',
                                    borderRadius: '12px'
                                }}>
                                    <CardHeader style={{
                                        background: 'linear-gradient(135deg, #0d3b59 0%, #1d5b83 100%)',
                                        color: 'white',
                                        padding: '15px',
                                        borderRadius: '12px 12px 0 0'
                                    }}>
                                        <h6 className="mb-0" style={{ fontWeight: 700, fontSize: '15px' }}>
                                            <i className="fa fa-filter mr-2"></i>Filtros de Búsqueda
                                        </h6>
                                    </CardHeader>
                                    <CardBody style={{ padding: '20px' }}>
                                        <FormGroup>
                                            <Label className='f-w-600 label-report'>
                                                <i className="fa fa-calendar-alt mr-2" style={{ color: '#007bff' }}></i>Fecha de inicio
                                            </Label>
                                            <Input
                                                type='date' value={mDateRange1} name='mDateRange1' onChange={handleInputChange} placeholder='YYYY-MM-DD'
                                                className='form-control'
                                                style={{
                                                    borderRadius: '8px',
                                                    border: '1px solid #ddd',
                                                    padding: '10px',
                                                    fontSize: '13px'
                                                }}
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label className='f-w-600 label-report'>
                                                <i className="fa fa-calendar-check mr-2" style={{ color: '#28a745' }}></i>Fecha de cierre
                                            </Label>
                                            <Input
                                                type='date' value={mDataRange2} name='mDataRange2' onChange={handleInputChange}
                                                className='form-control'
                                                placeholder='YYYY-MM-DD'
                                                style={{
                                                    borderRadius: '8px',
                                                    border: '1px solid #ddd',
                                                    padding: '10px',
                                                    fontSize: '13px'
                                                }}
                                            />
                                        </FormGroup>

                                        <FormGroup>
                                            <Label type="text" className='f-w-600 f-12 badge badge-light-primary'>Estatus</Label>
                                            <Select
                                                name="status"
                                                isClearable={true}
                                                placeholder="Selecciona un estatus"
                                                options={[
                                                    { value: "used", label: "Reclamado" },
                                                    { value: "unused", label: "Disponible" }
                                                ]}
                                                value={selectedStatus}
                                                onChange={(option) => setSelecUsed(option ? option.value : null)}
                                                styles={{ zIndex: "999999999999" }}
                                                menuPortalTarget={document.body}
                                            />

                                        </FormGroup>

                                        <br />
                                        <b>Acciones</b>
                                        <br /><br />
                                        <Button
                                            type="button"
                                            color="primary"
                                            block
                                            outline
                                            className="mb-3"
                                            onClick={(e) => getFilter(e)}
                                            style={{
                                                borderRadius: '10px',
                                                padding: '6px',
                                                fontSize: '14px',
                                                fontWeight: 600,
                                                borderWidth: '2px'
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                        >
                                            Buscar
                                        </Button>


                                    </CardBody>


                                </Card>
                            </Col>

                            <Col sm="10">
                                <div style={{
                                    marginTop: '1px',
                                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                    borderRadius: '12px',
                                    overflow: 'hidden',
                                    backgroundColor: '#fff'
                                }}>
                                    <Col sm="12" className='dark-mode-cancell'>

                                        <Card>
                                            <CardBody className='p-1'>
                                                <Col sm="12" className='p-l-0 p-r-0 pb-2 pt-3' >
                                                    <TitleDataTable
                                                        titleTable="Descuentos especiales"
                                                        buttonActions={handleExcelSpecialDiscount}
                                                        titleButton="listado de descuentos especiales"
                                                        isDisbled={loadingExport}
                                                        loadingIsDisabled={loadingExport}
                                                        titleCreate="Crear descuento especiales"
                                                        buttonActionsCreate={handleCreate}
                                                        actionInput={handleSearchDiscount}
                                                        valueFilter={searchDiscount}
                                                        filterLocalStorage={true}
                                                        cleanFilterLocalStorage={() => {
                                                            setSearchDiscount("");
                                                            setListSpecialDiscounts(listDiscountSearch);
                                                        }}
                                                    />

                                                </Col>

                                                <div className="table-responsive">
                                                    <DataTable
                                                        value={listSpecialDiscounts}
                                                        paginator
                                                        rows={10}
                                                        responsiveLayout="scroll"
                                                        rowsPerPageOptions={[10, 50, 100]}
                                                        className="data-table p-datatable-striped p-datatable-sm"
                                                        emptyMessage={
                                                            <div className="text-center">
                                                                <img
                                                                    src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                                    style={{ width: "32%" }}
                                                                    alt="Sin resultados"
                                                                />
                                                                <br />
                                                                <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                                                    No se encontraron resultados.
                                                                </p>
                                                            </div>
                                                        }
                                                    >

                                                        <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
                                                        <Column
                                                            header="Código"
                                                            headerStyle={headerStyle}
                                                            style={cellStyle}
                                                            body={(rowData) => {
                                                                const id = rowData.id_special_discount;

                                                                const formatted = `COD-${String(id).padStart(4, "0")}`;

                                                                return formatted;
                                                            }}
                                                        />
                                                        <Column
                                                            header="Descuento"
                                                            headerStyle={headerStyle}
                                                            style={cellStyle}
                                                            body={(rowData) => {

                                                                const isDisabled = rowData.status === "not authorized";

                                                                if (rowData.visibility) {
                                                                    return (
                                                                        <span
                                                                            style={{
                                                                                display: "inline-flex",
                                                                                alignItems: "center",
                                                                                gap: "6px",
                                                                                padding: "6px 10px",
                                                                                borderRadius: "8px",
                                                                                background: "linear-gradient(135deg, #278ed1, #009cbd)",
                                                                                color: "#fff",
                                                                                fontWeight: "600",
                                                                                fontSize: "13px",
                                                                                cursor: "default",
                                                                                boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                                                                                transition: "all 0.2s ease"
                                                                            }}
                                                                        >
                                                                            {rowData.code}
                                                                        </span>
                                                                    );
                                                                }

                                                                return (
                                                                    <span
                                                                        className={`blur-code ${!isDisabled ? "clickable" : ""}`}
                                                                        onClick={() => {
                                                                            if (isDisabled) return;
                                                                            handleShowValidCode(rowData.id_special_discount);
                                                                        }}
                                                                        style={{
                                                                            cursor: isDisabled ? "not-allowed" : "pointer",
                                                                            opacity: isDisabled ? 0.4 : 1
                                                                        }}
                                                                        title={isDisabled ? "No autorizado" : "Click para ver código"}
                                                                    >
                                                                        {rowData.code}
                                                                    </span>
                                                                );
                                                            }}
                                                        />
                                                        <Column field="name_user_created" header="Creado" headerStyle={headerStyle} style={cellStyle} />
                                                        <Column
                                                            header="Autorizado"
                                                            headerStyle={headerStyle}
                                                            style={cellStyle}
                                                            body={(rowData) => (
                                                                rowData.name_user_authorized ? (
                                                                    rowData.name_user_authorized
                                                                ) : (
                                                                    <span className="no-auth">Sin autorizar</span>
                                                                )
                                                            )}
                                                        />
                                                        <Column
                                                            header="Estatus"
                                                            headerStyle={headerStyle}
                                                            style={cellStyle}
                                                            body={(rowData) => {
                                                                const isAuthorized = rowData.id_authorized != null;
                                                                const isUsed = rowData.used_at != null;

                                                                let text = "";
                                                                let statusClass = "";

                                                                if (!isAuthorized) {
                                                                    text = "SIN AUTORIZAR";
                                                                    statusClass = "status-warning";
                                                                }
                                                                else if (isUsed) {
                                                                    text = "RECLAMADO";
                                                                    statusClass = "status-danger";
                                                                }
                                                                else {
                                                                    text = "DISPONIBLE";
                                                                    statusClass = "status-success";
                                                                }

                                                                return (
                                                                    <span className={`discount-status ${statusClass}`}>
                                                                        <span className="discount-status-dot"></span>
                                                                        {text}
                                                                    </span>
                                                                );
                                                            }}
                                                        />
                                                        <Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={centerStyle} />

                                                    </DataTable>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Card>

                {showDeleteAlert && (
                    <AlertDataTable
                        titleAlert="Eliminar descuento"
                        visibleAlert={modalAlert}
                        onHideAlert={closeDeleteAlert}
                        sizeAlert="medium-dialog delete-method"
                        messageAlert="Esta acción no se puede deshacer. ¿Estás seguro de eliminar el descuento?"
                        alert1={true}
                        titleAlert1={`COD-${String(idSpecialDiscount).padStart(4, "0")}`}
                        buttonAcept
                        titleNotLoading="Eliminar"
                        titleDanger="Cancelar"
                        actionAcept={saveDelete}
                    />

                )}


            </Container>
            <ModalInformation
                {
                ...{
                    modalInformation, toggleInformation, validCode, password, handleInputChange, getInformationSpecialDiscount, validName, valid_percentage
                }
                }
            />
            <ModalSpecialDiscount
                {
                ...{
                    modalSpecialDiscount, closeDialogSpecialDiscount, methodSpecialDiscount, modalTitle,
                    loading, percentage, percentage_global, listExams, listProfiles, listSelectedExams, listSelectedProfiles,
                    idSpecialDiscount, id_exam_include, id_profile_include,
                    handleInputChange, handleChangeTypeDiscount, handleExamsIncludes, handleProfileIncludes, handleInputPercentageIndividual,
                    validationsSpecialDiscount,
                    saveCreate,
                    handleRemoveTest,
                    saveAuthorized, saveUpdate, saveDelete, validName, handleSearchChange
                }
                }
            />
        </Fragment>
    )
}
